<template lang="html">
  <div class="status-page">
    <div class="status-page__content">
      <v-img
        :src="illustration"
        :alt="illustrationAlt"
        class="status-page__illustration"
        max-width="300"
        contain></v-img>
      <span class="status-page__code">{{ code }}</span>
      <h1 class="status-page__title">{{ title }}</h1>
      <p class="status-page__message">{{ message }}</p>
      <div class="status-page__actions">
        <v-btn color="primary" large rounded depressed min-width="180" @click="goBack()">
          <v-icon left>mdi-arrow-left</v-icon>
          Go back
        </v-btn>
        <v-btn color="primary" large rounded text min-width="180" @click="goToHome()">
          Go to home
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
  /**
   * StatusPage - the full-page status screen shared by Access restricted (403) and Page not found
   * (404): illustration, caption, title, one message, and the Go back / Go to home actions. The
   * layout lives here only, so the status pages cannot drift apart.
   */
  export default {
    name: 'StatusPage',
    props: {
      /** Image URL under public/ (e.g. /img/not-found-page.svg). */
      illustration: { type: String, required: true },
      illustrationAlt: { type: String, required: true },
      /** Caption above the title, e.g. "403 · Restricted"; shown in capitals. */
      code: { type: String, required: true },
      title: { type: String, required: true },
      message: { type: String, required: true },
    },
    methods: {
      goBack() {
        this.$router.go(-1);
      },
      goToHome() {
        this.$router.push('/');
      },
    },
  };
</script>

<style lang="scss" scoped>
  .status-page {
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 32px 24px;
  }

  .status-page__content {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    max-width: 560px;
  }

  .status-page__illustration {
    width: 100%;
    margin-bottom: 40px;
  }

  .status-page__code {
    font-family: var(--ds-font-family-body);
    font-size: var(--ds-font-caption);
    font-weight: 600;
    letter-spacing: 0.14em;
    text-transform: uppercase;
    color: var(--ds-color-neutral-hover);
    margin-bottom: 8px;
  }

  .status-page__title {
    font-family: var(--ds-font-family-heading);
    font-size: 2rem;
    font-weight: 600;
    line-height: 1.2;
    margin-bottom: 12px;
  }

  .status-page__message {
    font-family: var(--ds-font-family-body);
    font-size: var(--ds-font-subtitle);
    line-height: 1.6;
    color: var(--ds-color-neutral-hover);
    max-width: 44ch;
    margin-bottom: 32px;
  }

  .status-page__actions {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 12px;
  }

  @media (max-width: 600px) {
    .status-page__illustration {
      max-width: 220px;
      margin-bottom: 28px;
    }

    .status-page__title {
      font-size: 1.6rem;
    }
  }
</style>
